module.exports = __webpack_public_path__ + "static/media/CalendarIcon1.1c6a0a4e.svg";